package org.vreo.devicehub.features.core.domain.device.imageRequest

/**
 * Static image request. Allows to request and obtain latest image/frame from device.
 *
 * @property config platform specific configuration encoded, this can be as base64 encoded.
 * @property imageBase64 base64 encoded image
 */
data class StaticImageRequest(
    val config: String? = null,
    val imageBase64: String? = null
)